import { render, staticRenderFns } from "./IconBranding.vue?vue&type=template&id=51956c9e&"
import script from "./IconBranding.vue?vue&type=script&lang=ts&"
export * from "./IconBranding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports